import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useEditorStore, PPM } from '../../store/editorStore'
import { calibrateUnderlay, getUnderlayCrop } from '../../utils/underlayCalibration.logic'

export function BackgroundUnderlay() {
  const underlay = useEditorStore(state => state.dcSettings.backgroundUnderlay)
  const { stageX, stageY, stageScale } = useEditorStore(useShallow(state => ({ stageX: state.stageX, stageY: state.stageY, stageScale: state.stageScale })))

  const layout = useMemo(() => {
    if (!underlay || !underlay.source) return null
    try {
      const crop = getUnderlayCrop(underlay)
      const calibration = calibrateUnderlay(underlay)
      const pixelsToScreen = calibration.metresPerPixel * PPM * stageScale
      return {
        crop,
        left: stageX + underlay.originXMm / 1000 * PPM * stageScale,
        top: stageY + underlay.originYMm / 1000 * PPM * stageScale,
        width: crop.widthPx * pixelsToScreen,
        height: crop.heightPx * pixelsToScreen,
        imageWidth: underlay.sourceWidthPx * pixelsToScreen,
        imageHeight: underlay.sourceHeightPx * pixelsToScreen,
        imageLeft: -crop.xPx * pixelsToScreen,
        imageTop: -crop.yPx * pixelsToScreen,
      }
    } catch {
      return null
    }
  }, [underlay, stageX, stageY, stageScale])

  if (!underlay || !layout) return null

  const sourceStyle = {
    position: 'absolute' as const,
    left: layout.imageLeft,
    top: layout.imageTop,
    width: layout.imageWidth,
    height: layout.imageHeight,
    maxWidth: 'none',
    pointerEvents: 'none' as const,
    userSelect: 'none' as const,
  }

  return (
    <div
      className={`editor-background-underlay is-${underlay.ordering}`}
      aria-hidden="true"
      style={{
        left: layout.left,
        top: layout.top,
        width: layout.width,
        height: layout.height,
        opacity: underlay.opacity,
        transform: `rotate(${underlay.rotationDeg}deg)`,
      }}
    >
      {underlay.kind === 'pdf' ? <iframe title="Подложка PDF" src={underlay.source} style={sourceStyle} /> : <img src={underlay.source} alt="" draggable={false} style={sourceStyle} />}
    </div>
  )
}
